
import {css} from "@benev/slate"
export default css`

:host {
	display: contents;
}

slot {
	display: contents;
}

`

